import { updateOrderItem } from "@/api/order-api";
import { toast } from "@/hooks/use-toast";
import { OrderItemResponse, OrderResponse, UpdateOrderItem } from "@/types/order-type";
import { useState } from "react";

export function useEditOrderItem(order: OrderResponse | null | undefined, refresh: () => void) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [editingItem, setEditingItem] = useState<OrderItemResponse | null>(null);
    const [tempQty, setTempQty] = useState<number>(0);
    const [tempPrice, setTempPrice] = useState<number>(0);

    const handleEditClick = (item: OrderItemResponse) => {
        setEditingItem(item);
        setTempQty(item.quantity);
        setTempPrice(Number(item.price));
    };
    const handleUpdateItem = async (itemId: string, newQty: number, newPrice: number) => {
        if (!order) return;

        const updateData: UpdateOrderItem = {
            id: itemId,
            orderId: order.id,
            quantity: newQty,
            price: newPrice
        } as UpdateOrderItem;
        const resp = await updateOrderItem(itemId, updateData);
        if (resp.success) {
            toast({ title: "Success", description: "Update order item successfully" });
            setEditingItem(null);
            refresh();
        }
        else {
            const detailMsg = resp.details
                ? Array.isArray(resp.details)
                    ? resp.details[0]
                    : Object.values(resp.details)[0]
                : undefined;
            const errMsg = detailMsg || (Array.isArray(resp.errors) ? resp.errors[0] : resp.errors) || resp.message || "Error on update order item!";
            toast({ title: "Error update", description: errMsg, variant: "destructive" });
        }
        setIsDialogOpen(false);
    }


    const handleCancel = () => {
        setEditingItem(null);
    };
    return {
        isDialogOpen,
        handleEditClick,
        handleUpdateItem,
        handleCancel,
        editingItem,
        tempQty,
        tempPrice,
        setTempQty,
        setTempPrice,
        setIsDialogOpen,
        setEditingItem

    }
}
